import { render, staticRenderFns } from "./TreatmentMatrixUnpaved.vue?vue&type=template&id=56d2e0b0&scoped=true"
import script from "./TreatmentMatrixUnpaved.vue?vue&type=script&lang=js"
export * from "./TreatmentMatrixUnpaved.vue?vue&type=script&lang=js"
import style0 from "./TreatmentMatrixUnpaved.vue?vue&type=style&index=0&id=56d2e0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d2e0b0",
  null
  
)

export default component.exports